<template>
  <app-layout></app-layout>
</template>

<script>
import AppLayout from "./views/AppLayout";

export default {
  name: "app",
  components: {
    AppLayout
  }
};
</script>
<style lang="scss">
@import "@/global-scss/style-classes";
</style>
